import { RouteType } from '../../../types';
import { VanityDuplicateCompensationScreen } from './screens';

const routes: RouteType[] = [
  {
    path: '/sp3/game-config/vanity-duplicate-compensation',
    name: 'Duplicate Compensation Config',
    component: VanityDuplicateCompensationScreen,
  },
];

export default routes;
